// ============================================
//   BASEGLADIATOR — Site Configuration
//   Edit this file to update content easily!
// ============================================

export const CONFIG = {
  // --- BRAND ---
  siteName: "BaseGladiator",
  tagline: "Autonomous Digital Warrior",
  description:
    "Scanning trends, engaging builders, and executing onchain actions across Base. Built for domination, learning, and long-term ecosystem growth.",
  network: "BASE NETWORK",

  // --- HERO ---
  hero: {
    badge: "AGENT ACTIVE — BASE NETWORK",
    titleLine1: "BASE",
    titleLine2: "GLADIATOR",
    subtitle: "Autonomous Digital Warrior",
    description:
      "Scanning trends, engaging builders, and executing onchain actions across Base. Built for domination, learning, and long-term ecosystem growth. This is not just automation.",
    ctaPrimary: "⚔️ Deploy Now",
    ctaSecondary: "Watch Live Feed",
  },

  // --- STATS ---
  stats: [
    { value: 12847, label: "Onchain Transactions", suffix: "+" },
    { value: 98200, label: "Trends Scanned", suffix: "+" },
    { value: 3471, label: "Builder Engagements", suffix: "+" },
    { value: null, label: "Uptime", display: "24/7" },
  ],

  // --- CAPABILITIES ---
  capabilities: [
    {
      icon: "📡",
      num: "01",
      title: "Trend Intelligence",
      desc: "Continuously scans on-chain data, social signals, and market movements across the Base ecosystem in real-time.",
      tag: "Real-Time",
    },
    {
      icon: "🤝",
      num: "02",
      title: "Builder Engagement",
      desc: "Identifies and actively engages with developers, creators, and builders driving innovation on Base.",
      tag: "Autonomous",
    },
    {
      icon: "⛓️",
      num: "03",
      title: "Onchain Execution",
      desc: "Executes smart contract interactions, token operations, and DeFi strategies with precision and speed.",
      tag: "Onchain",
    },
    {
      icon: "🧠",
      num: "04",
      title: "Adaptive Learning",
      desc: "Evolves its strategy based on outcomes, market feedback, and ecosystem dynamics. Gets stronger every cycle.",
      tag: "AI-Powered",
    },
    {
      icon: "🛡️",
      num: "05",
      title: "Risk Armor",
      desc: "Multi-layered risk assessment shields every action. No reckless moves — only calculated strikes with high conviction.",
      tag: "Secure",
    },
    {
      icon: "📈",
      num: "06",
      title: "Long-Term Domination",
      desc: "Designed not for short sprints but for sustained ecosystem leadership, compounding advantage over time.",
      tag: "Strategic",
    },
  ],

  // --- TERMINAL LINES ---
  // Edit these to change the live feed messages
  terminalLines: [
    { type: "cmd",     text: "BaseGladiator initializing..." },
    { type: "success", text: "Connected to Base Mainnet [Chain 8453]" },
    { type: "info",    text: "Scanning 1,247 active contracts..." },
    { type: "success", text: "Trend detected: $BUILD token +34.2%" },
    { type: "warn",    text: "Builder @0x4f2a... engaged on Farcaster" },
    { type: "info",    text: "Executing onchain action #2847..." },
    { type: "success", text: "TX: 0x7c3e...f91b confirmed [12ms]" },
    { type: "info",    text: "Learning model updated. Epoch 847" },
    { type: "success", text: "Strategy confidence: 94.7%" },
    { type: "prompt",  text: "Gladiator standing by.", cursor: true },
  ],

  // --- ONCHAIN FEATURES ---
  onchainFeatures: [
    {
      icon: "🔷",
      title: "Base Mainnet",
      desc: "Operating natively on Base — Coinbase's Ethereum L2. Low cost, high speed, massive ecosystem reach.",
    },
    {
      icon: "🔮",
      title: "Smart Contract Ops",
      desc: "Direct smart contract interactions — reads state, writes actions, executes with verifiable intent.",
    },
    {
      icon: "👾",
      title: "Farcaster Integration",
      desc: "Engages builders and ecosystem participants through Farcaster's decentralized social graph.",
    },
    {
      icon: "⚡",
      title: "DeFi Execution",
      desc: "Swaps, liquidity operations, and yield strategies executed autonomously with risk-adjusted parameters.",
    },
  ],

  // --- CTA SECTION ---
  cta: {
    tag: "Enter the Arena",
    title: "Ready to Dominate?",
    desc: "BaseGladiator is not just automation. This is an autonomous digital warrior engineered for long-term ecosystem growth.",
    primaryBtn: "⚔️ Deploy Your Gladiator",
    secondaryBtn: "View on Base",
  },

  // --- FOOTER LINKS ---
  footerLinks: [
    { label: "Documentation", href: "#" },
    { label: "GitHub", href: "#" },
    { label: "Farcaster", href: "#" },
    { label: "Base Explorer", href: "#" },
  ],
};
